module.exports = __webpack_public_path__ + "img/440.8aa11320.jpg";